<script>
    import {Bar} from 'vue-chartjs'

    export default {
        name: 'BarChart',
        extends: Bar,
        props: {
            dataArray: {
                required: true
            },
            labels: {
                required: true
            },
            test_size: {
                required: true
            }
        },
        mounted() {
            let chartFontSize = screen.width / 130;
            this.renderChart({
                labels: this.labels,
                datasets: this.dataArray
            }, {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    yAxes: [{
                        display: true,
                        ticks: {
                            suggestedMin: 1,    // minimum will be 0, unless there is a lower value.
                            // OR //
                            beginAtZero: true ,  // minimum value will be 0.
                            suggestedMax: this.test_size
                        }
                    }]
                },
                legend: {
                    display: false
                },
                plugins: {
                    datalabels: {
                        formatter: (value) => {
                            return value;
                        },
                        font: function() {
                            return {
                                size: chartFontSize
                            }
                        },
                        color: 'black'
                    }
                }
            })
        }
    }
</script>

<style scoped>

</style>